import { getObjectWithIdFromContainer } from '@fluidframework/aqueduct';
import { MFS_DATA_STORE_ID, MFS_VOLATILE_SESSION_ID, isMfsVolatileSession, } from '@metaos/mfs-client';
import { logVerboseAsync } from '@metaos/mfs-telemetry';
import { logger } from '../logger';
import { mfsError } from '../errors/loaderErrors';
/** Loads either MfsDataStore, MfsVolatileSession or both */
export async function loadDataObjects(dataObjectsToLoad, container, mfsApp, podId) {
    return logVerboseAsync(logger, 'loadDataObjects', async () => {
        const loadStore = (dataObjectsToLoad & 2 /* MfsDataStore */) === 2 /* MfsDataStore */;
        const loadSession = (dataObjectsToLoad & 4 /* MfsVolatileSession */) === 4 /* MfsVolatileSession */;
        if (loadStore && loadSession) {
            logger.logVerbose('loadDataObjects', `Returning MFS_DATA_STORE_ID: ${MFS_DATA_STORE_ID} and MFS_VOLATILE_SESSION_ID: ${MFS_VOLATILE_SESSION_ID}`);
            return Promise.all([
                loadMfsDataObject(MFS_DATA_STORE_ID, podId, container, mfsApp),
                loadMfsDataObject(MFS_VOLATILE_SESSION_ID, podId, container, mfsApp),
            ]).then((value) => {
                return {
                    dataStore: value[0],
                    volatileSession: value[1],
                };
            });
        }
        if (loadStore && !loadSession) {
            logger.logVerbose('loadDataObjects', `Returning MFS_DATA_STORE_ID: ${MFS_DATA_STORE_ID}`);
            const store = await loadMfsDataObject(MFS_DATA_STORE_ID, podId, container, mfsApp);
            return {
                dataStore: store,
            };
        }
        if (!loadStore && loadSession) {
            logger.logVerbose('loadDataObjects', `Returning MFS_VOLATILE_SESSION_ID: ${MFS_VOLATILE_SESSION_ID}`);
            const volatileSession = await loadMfsDataObject(MFS_VOLATILE_SESSION_ID, podId, container, mfsApp, true);
            return {
                volatileSession: volatileSession,
            };
        }
        logger.logVerbose('loadDataObjects', 'Invalid dataObjectsToLoad:', { dataObjectsToLoad });
        throw mfsError.invalidLoadOptions();
    });
}
/** Loads the MfsFluidSystemDataStore data object */
export async function loadMfsSystemDataObject(container) {
    return logVerboseAsync(logger, 'loadMfsSystemDataObject', async () => {
        logger.logVerbose('loadMfsSystemDataObject', `Getting object with MFS_VOLATILE_SESSION_ID: ${MFS_VOLATILE_SESSION_ID}`);
        return getObjectWithIdFromContainer(MFS_VOLATILE_SESSION_ID, container);
    });
}
/** Loads either an MfsFluidDataStore or a MfsFluidVolatileSession data object */
async function loadMfsDataObject(dataStoreId, podId, container, mfsApp, onlyVolatileSession = false) {
    return logVerboseAsync(logger, 'loadMfsDataObject', async () => {
        const dataStore = await getObjectWithIdFromContainer(dataStoreId, container);
        logger.logVerbose('loadMfsDataObject', 'Initializing datastore', { dataStoreId, podId, onlyVolatileSession });
        dataStore.setHost(mfsApp);
        dataStore.setId(podId);
        if (isMfsVolatileSession(dataStore)) {
            logger.logVerbose('loadMfsDataObject', 'Initializing MfsFluidVolatileSession');
            dataStore.initSession();
            dataStore.registerVolatileAudience(onlyVolatileSession);
        }
        return dataStore;
    });
}
//# sourceMappingURL=dataObjectLoadingUtils.js.map